import {grey} from "@material-ui/core/colors";
import InputBase from "@material-ui/core/InputBase";
import withStyles from "@material-ui/core/styles/withStyles";
import {memo} from "react";

const BootstrapInput = withStyles(theme => {
    return ({
        input: {
            borderRadius: 4,
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${grey[300]}`,
            fontSize: theme.typography.fontSize,
            padding: theme.spacing(1),
            transition: theme.transitions.create(["border-color", "box-shadow"]),
            "&:focus": {
                borderRadius: 4,
                borderColor: theme.palette.primary.main,
                boxShadow: "0 0 0 0.2rem rgba(43,140,161,.25)"
            }
        }
    });
})(InputBase);

export default memo(BootstrapInput);
